module.exports = {
	"contractName": "Bank",
	"abi": [
		{
			"constant": true,
			"inputs": [],
			"name": "totalSupply",
			"outputs": [
				{
					"name": "",
					"type": "uint256"
				}
			],
			"payable": false,
			"stateMutability": "view",
			"type": "function"
		},
		{
			"inputs": [
				{
					"name": "_initialSupply",
					"type": "uint256"
				}
			],
			"payable": false,
			"stateMutability": "nonpayable",
			"type": "constructor"
		},
		{
			"constant": false,
			"inputs": [
				{
					"name": "_to",
					"type": "address"
				},
				{
					"name": "_value",
					"type": "uint256"
				}
			],
			"name": "transfer",
			"outputs": [
				{
					"name": "",
					"type": "bool"
				}
			],
			"payable": false,
			"stateMutability": "nonpayable",
			"type": "function"
		},
		{
			"constant": true,
			"inputs": [
				{
					"name": "_owner",
					"type": "address"
				}
			],
			"name": "balanceOf",
			"outputs": [
				{
					"name": "balance",
					"type": "uint256"
				}
			],
			"payable": false,
			"stateMutability": "view",
			"type": "function"
		}
	],
	"bytecode": "0x608060405234801561001057600080fd5b506040516020806101f883398101604090815290516001819055336000908152602081905291909120556101af806100496000396000f3006080604052600436106100565763ffffffff7c010000000000000000000000000000000000000000000000000000000060003504166318160ddd811461005b57806370a0823114610082578063a9059cbb146100b0575b600080fd5b34801561006757600080fd5b506100706100f5565b60408051918252519081900360200190f35b34801561008e57600080fd5b5061007073ffffffffffffffffffffffffffffffffffffffff600435166100fb565b3480156100bc57600080fd5b506100e173ffffffffffffffffffffffffffffffffffffffff60043516602435610123565b604080519115158252519081900360200190f35b60015481565b73ffffffffffffffffffffffffffffffffffffffff1660009081526020819052604090205490565b3360009081526020819052604081205482900381111561014257600080fd5b50336000908152602081905260408082208054849003905573ffffffffffffffffffffffffffffffffffffffff8416825290208054820190556001929150505600a165627a7a7230582067dccc1821976b447c67104a78f4a0ecc06196b9243d28939f6bf94643f79d510029",
	"deployedBytecode": "0x6080604052600436106100565763ffffffff7c010000000000000000000000000000000000000000000000000000000060003504166318160ddd811461005b57806370a0823114610082578063a9059cbb146100b0575b600080fd5b34801561006757600080fd5b506100706100f5565b60408051918252519081900360200190f35b34801561008e57600080fd5b5061007073ffffffffffffffffffffffffffffffffffffffff600435166100fb565b3480156100bc57600080fd5b506100e173ffffffffffffffffffffffffffffffffffffffff60043516602435610123565b604080519115158252519081900360200190f35b60015481565b73ffffffffffffffffffffffffffffffffffffffff1660009081526020819052604090205490565b3360009081526020819052604081205482900381111561014257600080fd5b50336000908152602081905260408082208054849003905573ffffffffffffffffffffffffffffffffffffffff8416825290208054820190556001929150505600a165627a7a7230582067dccc1821976b447c67104a78f4a0ecc06196b9243d28939f6bf94643f79d510029",
	"sourceMap": "26:518:1:-;;;115:107;8:9:-1;5:2;;;30:1;27;20:12;5:2;115:107:1;;;;;;;;;;;;;;;;189:11;:28;;;175:10;166:8;:20;;;115:107;166:20;;;;;;;:51;26:518;;;;;;",
	"deployedSourceMap": "26:518:1:-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;84:26;;8:9:-1;5:2;;;30:1;27;20:12;5:2;84:26:1;;;;;;;;;;;;;;;;;;;;435:107;;8:9:-1;5:2;;;30:1;27;20:12;5:2;-1:-1;435:107:1;;;;;;;226:205;;8:9:-1;5:2;;;30:1;27;20:12;5:2;-1:-1;226:205:1;;;;;;;;;;;;;;;;;;;;;;;;;;;84:26;;;;:::o;435:107::-;521:16;;491:15;521:16;;;;;;;;;;;;435:107::o;226:205::-;318:10;289:4;309:20;;;;;;;;;;;:29;;;:34;-1:-1:-1;309:34:1;301:43;;;;;;-1:-1:-1;359:10:1;350:8;:20;;;;;;;;;;;:30;;;;;;;:20;386:13;;;;;;:23;;;;;;-1:-1:-1;226:205:1;;;;:::o",
	"source": "pragma solidity ^0.4.18;\n\ncontract Bank {\n  mapping(address => uint256) balances;\n  uint256 public totalSupply;\n\n  function Bank(uint256 _initialSupply) public {\n    balances[msg.sender] = totalSupply = _initialSupply;\n  }\n\n  function transfer(address _to, uint256 _value) public returns (bool) {\n    require(balances[msg.sender] - _value >= 0);\n    balances[msg.sender] -= _value;\n    balances[_to] += _value;\n    return true;\n  }\n\n  function balanceOf(address _owner) public view returns (uint256 balance) {\n    return balances[_owner];\n  }\n}\n",
	"sourcePath": "/Users/billhsu/Desktop/work/github/cypherpunks-ctf/contracts/levels/Bank.sol",
	"ast": {
		"absolutePath": "/Users/billhsu/Desktop/work/github/cypherpunks-ctf/contracts/levels/Bank.sol",
		"exportedSymbols": {
			"Bank": [
				209
			]
		},
		"id": 210,
		"nodeType": "SourceUnit",
		"nodes": [
			{
				"id": 139,
				"literals": [
					"solidity",
					"^",
					"0.4",
					".18"
				],
				"nodeType": "PragmaDirective",
				"src": "0:24:1"
			},
			{
				"baseContracts": [],
				"contractDependencies": [],
				"contractKind": "contract",
				"documentation": null,
				"fullyImplemented": true,
				"id": 209,
				"linearizedBaseContracts": [
					209
				],
				"name": "Bank",
				"nodeType": "ContractDefinition",
				"nodes": [
					{
						"constant": false,
						"id": 143,
						"name": "balances",
						"nodeType": "VariableDeclaration",
						"scope": 209,
						"src": "44:36:1",
						"stateVariable": true,
						"storageLocation": "default",
						"typeDescriptions": {
							"typeIdentifier": "t_mapping$_t_address_$_t_uint256_$",
							"typeString": "mapping(address => uint256)"
						},
						"typeName": {
							"id": 142,
							"keyType": {
								"id": 140,
								"name": "address",
								"nodeType": "ElementaryTypeName",
								"src": "52:7:1",
								"typeDescriptions": {
									"typeIdentifier": "t_address",
									"typeString": "address"
								}
							},
							"nodeType": "Mapping",
							"src": "44:27:1",
							"typeDescriptions": {
								"typeIdentifier": "t_mapping$_t_address_$_t_uint256_$",
								"typeString": "mapping(address => uint256)"
							},
							"valueType": {
								"id": 141,
								"name": "uint256",
								"nodeType": "ElementaryTypeName",
								"src": "63:7:1",
								"typeDescriptions": {
									"typeIdentifier": "t_uint256",
									"typeString": "uint256"
								}
							}
						},
						"value": null,
						"visibility": "internal"
					},
					{
						"constant": false,
						"id": 145,
						"name": "totalSupply",
						"nodeType": "VariableDeclaration",
						"scope": 209,
						"src": "84:26:1",
						"stateVariable": true,
						"storageLocation": "default",
						"typeDescriptions": {
							"typeIdentifier": "t_uint256",
							"typeString": "uint256"
						},
						"typeName": {
							"id": 144,
							"name": "uint256",
							"nodeType": "ElementaryTypeName",
							"src": "84:7:1",
							"typeDescriptions": {
								"typeIdentifier": "t_uint256",
								"typeString": "uint256"
							}
						},
						"value": null,
						"visibility": "public"
					},
					{
						"body": {
							"id": 159,
							"nodeType": "Block",
							"src": "160:62:1",
							"statements": [
								{
									"expression": {
										"argumentTypes": null,
										"id": 157,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"id": 150,
												"name": "balances",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 143,
												"src": "166:8:1",
												"typeDescriptions": {
													"typeIdentifier": "t_mapping$_t_address_$_t_uint256_$",
													"typeString": "mapping(address => uint256)"
												}
											},
											"id": 153,
											"indexExpression": {
												"argumentTypes": null,
												"expression": {
													"argumentTypes": null,
													"id": 151,
													"name": "msg",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 2937,
													"src": "175:3:1",
													"typeDescriptions": {
														"typeIdentifier": "t_magic_message",
														"typeString": "msg"
													}
												},
												"id": 152,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"memberName": "sender",
												"nodeType": "MemberAccess",
												"referencedDeclaration": null,
												"src": "175:10:1",
												"typeDescriptions": {
													"typeIdentifier": "t_address",
													"typeString": "address"
												}
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "166:20:1",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"id": 156,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"id": 154,
												"name": "totalSupply",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 145,
												"src": "189:11:1",
												"typeDescriptions": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"id": 155,
												"name": "_initialSupply",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 147,
												"src": "203:14:1",
												"typeDescriptions": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												}
											},
											"src": "189:28:1",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"src": "166:51:1",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"id": 158,
									"nodeType": "ExpressionStatement",
									"src": "166:51:1"
								}
							]
						},
						"documentation": null,
						"id": 160,
						"implemented": true,
						"isConstructor": true,
						"isDeclaredConst": false,
						"modifiers": [],
						"name": "Bank",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 148,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 147,
									"name": "_initialSupply",
									"nodeType": "VariableDeclaration",
									"scope": 160,
									"src": "129:22:1",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_uint256",
										"typeString": "uint256"
									},
									"typeName": {
										"id": 146,
										"name": "uint256",
										"nodeType": "ElementaryTypeName",
										"src": "129:7:1",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "128:24:1"
						},
						"payable": false,
						"returnParameters": {
							"id": 149,
							"nodeType": "ParameterList",
							"parameters": [],
							"src": "160:0:1"
						},
						"scope": 209,
						"src": "115:107:1",
						"stateMutability": "nonpayable",
						"superFunction": null,
						"visibility": "public"
					},
					{
						"body": {
							"id": 195,
							"nodeType": "Block",
							"src": "295:136:1",
							"statements": [
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"commonType": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												},
												"id": 177,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"leftExpression": {
													"argumentTypes": null,
													"commonType": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													},
													"id": 175,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"leftExpression": {
														"argumentTypes": null,
														"baseExpression": {
															"argumentTypes": null,
															"id": 170,
															"name": "balances",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 143,
															"src": "309:8:1",
															"typeDescriptions": {
																"typeIdentifier": "t_mapping$_t_address_$_t_uint256_$",
																"typeString": "mapping(address => uint256)"
															}
														},
														"id": 173,
														"indexExpression": {
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 171,
																"name": "msg",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 2937,
																"src": "318:3:1",
																"typeDescriptions": {
																	"typeIdentifier": "t_magic_message",
																	"typeString": "msg"
																}
															},
															"id": 172,
															"isConstant": false,
															"isLValue": false,
															"isPure": false,
															"lValueRequested": false,
															"memberName": "sender",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "318:10:1",
															"typeDescriptions": {
																"typeIdentifier": "t_address",
																"typeString": "address"
															}
														},
														"isConstant": false,
														"isLValue": true,
														"isPure": false,
														"lValueRequested": false,
														"nodeType": "IndexAccess",
														"src": "309:20:1",
														"typeDescriptions": {
															"typeIdentifier": "t_uint256",
															"typeString": "uint256"
														}
													},
													"nodeType": "BinaryOperation",
													"operator": "-",
													"rightExpression": {
														"argumentTypes": null,
														"id": 174,
														"name": "_value",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 164,
														"src": "332:6:1",
														"typeDescriptions": {
															"typeIdentifier": "t_uint256",
															"typeString": "uint256"
														}
													},
													"src": "309:29:1",
													"typeDescriptions": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												},
												"nodeType": "BinaryOperation",
												"operator": ">=",
												"rightExpression": {
													"argumentTypes": null,
													"hexValue": "30",
													"id": 176,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "342:1:1",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_0_by_1",
														"typeString": "int_const 0"
													},
													"value": "0"
												},
												"src": "309:34:1",
												"typeDescriptions": {
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											],
											"id": 169,
											"name": "require",
											"nodeType": "Identifier",
											"overloadedDeclarations": [
												2940,
												2941
											],
											"referencedDeclaration": 2940,
											"src": "301:7:1",
											"typeDescriptions": {
												"typeIdentifier": "t_function_require_pure$_t_bool_$returns$__$",
												"typeString": "function (bool) pure"
											}
										},
										"id": 178,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "301:43:1",
										"typeDescriptions": {
											"typeIdentifier": "t_tuple$__$",
											"typeString": "tuple()"
										}
									},
									"id": 179,
									"nodeType": "ExpressionStatement",
									"src": "301:43:1"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 185,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"id": 180,
												"name": "balances",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 143,
												"src": "350:8:1",
												"typeDescriptions": {
													"typeIdentifier": "t_mapping$_t_address_$_t_uint256_$",
													"typeString": "mapping(address => uint256)"
												}
											},
											"id": 183,
											"indexExpression": {
												"argumentTypes": null,
												"expression": {
													"argumentTypes": null,
													"id": 181,
													"name": "msg",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 2937,
													"src": "359:3:1",
													"typeDescriptions": {
														"typeIdentifier": "t_magic_message",
														"typeString": "msg"
													}
												},
												"id": 182,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"memberName": "sender",
												"nodeType": "MemberAccess",
												"referencedDeclaration": null,
												"src": "359:10:1",
												"typeDescriptions": {
													"typeIdentifier": "t_address",
													"typeString": "address"
												}
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "350:20:1",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"nodeType": "Assignment",
										"operator": "-=",
										"rightHandSide": {
											"argumentTypes": null,
											"id": 184,
											"name": "_value",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 164,
											"src": "374:6:1",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"src": "350:30:1",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"id": 186,
									"nodeType": "ExpressionStatement",
									"src": "350:30:1"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 191,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"id": 187,
												"name": "balances",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 143,
												"src": "386:8:1",
												"typeDescriptions": {
													"typeIdentifier": "t_mapping$_t_address_$_t_uint256_$",
													"typeString": "mapping(address => uint256)"
												}
											},
											"id": 189,
											"indexExpression": {
												"argumentTypes": null,
												"id": 188,
												"name": "_to",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 162,
												"src": "395:3:1",
												"typeDescriptions": {
													"typeIdentifier": "t_address",
													"typeString": "address"
												}
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "386:13:1",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"nodeType": "Assignment",
										"operator": "+=",
										"rightHandSide": {
											"argumentTypes": null,
											"id": 190,
											"name": "_value",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 164,
											"src": "403:6:1",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"src": "386:23:1",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"id": 192,
									"nodeType": "ExpressionStatement",
									"src": "386:23:1"
								},
								{
									"expression": {
										"argumentTypes": null,
										"hexValue": "74727565",
										"id": 193,
										"isConstant": false,
										"isLValue": false,
										"isPure": true,
										"kind": "bool",
										"lValueRequested": false,
										"nodeType": "Literal",
										"src": "422:4:1",
										"subdenomination": null,
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										},
										"value": "true"
									},
									"functionReturnParameters": 168,
									"id": 194,
									"nodeType": "Return",
									"src": "415:11:1"
								}
							]
						},
						"documentation": null,
						"id": 196,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": false,
						"modifiers": [],
						"name": "transfer",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 165,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 162,
									"name": "_to",
									"nodeType": "VariableDeclaration",
									"scope": 196,
									"src": "244:11:1",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_address",
										"typeString": "address"
									},
									"typeName": {
										"id": 161,
										"name": "address",
										"nodeType": "ElementaryTypeName",
										"src": "244:7:1",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"value": null,
									"visibility": "internal"
								},
								{
									"constant": false,
									"id": 164,
									"name": "_value",
									"nodeType": "VariableDeclaration",
									"scope": 196,
									"src": "257:14:1",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_uint256",
										"typeString": "uint256"
									},
									"typeName": {
										"id": 163,
										"name": "uint256",
										"nodeType": "ElementaryTypeName",
										"src": "257:7:1",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "243:29:1"
						},
						"payable": false,
						"returnParameters": {
							"id": 168,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 167,
									"name": "",
									"nodeType": "VariableDeclaration",
									"scope": 196,
									"src": "289:4:1",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_bool",
										"typeString": "bool"
									},
									"typeName": {
										"id": 166,
										"name": "bool",
										"nodeType": "ElementaryTypeName",
										"src": "289:4:1",
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "288:6:1"
						},
						"scope": 209,
						"src": "226:205:1",
						"stateMutability": "nonpayable",
						"superFunction": null,
						"visibility": "public"
					},
					{
						"body": {
							"id": 207,
							"nodeType": "Block",
							"src": "508:34:1",
							"statements": [
								{
									"expression": {
										"argumentTypes": null,
										"baseExpression": {
											"argumentTypes": null,
											"id": 203,
											"name": "balances",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 143,
											"src": "521:8:1",
											"typeDescriptions": {
												"typeIdentifier": "t_mapping$_t_address_$_t_uint256_$",
												"typeString": "mapping(address => uint256)"
											}
										},
										"id": 205,
										"indexExpression": {
											"argumentTypes": null,
											"id": 204,
											"name": "_owner",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 198,
											"src": "530:6:1",
											"typeDescriptions": {
												"typeIdentifier": "t_address",
												"typeString": "address"
											}
										},
										"isConstant": false,
										"isLValue": true,
										"isPure": false,
										"lValueRequested": false,
										"nodeType": "IndexAccess",
										"src": "521:16:1",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"functionReturnParameters": 202,
									"id": 206,
									"nodeType": "Return",
									"src": "514:23:1"
								}
							]
						},
						"documentation": null,
						"id": 208,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": true,
						"modifiers": [],
						"name": "balanceOf",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 199,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 198,
									"name": "_owner",
									"nodeType": "VariableDeclaration",
									"scope": 208,
									"src": "454:14:1",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_address",
										"typeString": "address"
									},
									"typeName": {
										"id": 197,
										"name": "address",
										"nodeType": "ElementaryTypeName",
										"src": "454:7:1",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "453:16:1"
						},
						"payable": false,
						"returnParameters": {
							"id": 202,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 201,
									"name": "balance",
									"nodeType": "VariableDeclaration",
									"scope": 208,
									"src": "491:15:1",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_uint256",
										"typeString": "uint256"
									},
									"typeName": {
										"id": 200,
										"name": "uint256",
										"nodeType": "ElementaryTypeName",
										"src": "491:7:1",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "490:17:1"
						},
						"scope": 209,
						"src": "435:107:1",
						"stateMutability": "view",
						"superFunction": null,
						"visibility": "public"
					}
				],
				"scope": 210,
				"src": "26:518:1"
			}
		],
		"src": "0:545:1"
	},
	"legacyAST": {
		"absolutePath": "/Users/billhsu/Desktop/work/github/cypherpunks-ctf/contracts/levels/Bank.sol",
		"exportedSymbols": {
			"Bank": [
				209
			]
		},
		"id": 210,
		"nodeType": "SourceUnit",
		"nodes": [
			{
				"id": 139,
				"literals": [
					"solidity",
					"^",
					"0.4",
					".18"
				],
				"nodeType": "PragmaDirective",
				"src": "0:24:1"
			},
			{
				"baseContracts": [],
				"contractDependencies": [],
				"contractKind": "contract",
				"documentation": null,
				"fullyImplemented": true,
				"id": 209,
				"linearizedBaseContracts": [
					209
				],
				"name": "Bank",
				"nodeType": "ContractDefinition",
				"nodes": [
					{
						"constant": false,
						"id": 143,
						"name": "balances",
						"nodeType": "VariableDeclaration",
						"scope": 209,
						"src": "44:36:1",
						"stateVariable": true,
						"storageLocation": "default",
						"typeDescriptions": {
							"typeIdentifier": "t_mapping$_t_address_$_t_uint256_$",
							"typeString": "mapping(address => uint256)"
						},
						"typeName": {
							"id": 142,
							"keyType": {
								"id": 140,
								"name": "address",
								"nodeType": "ElementaryTypeName",
								"src": "52:7:1",
								"typeDescriptions": {
									"typeIdentifier": "t_address",
									"typeString": "address"
								}
							},
							"nodeType": "Mapping",
							"src": "44:27:1",
							"typeDescriptions": {
								"typeIdentifier": "t_mapping$_t_address_$_t_uint256_$",
								"typeString": "mapping(address => uint256)"
							},
							"valueType": {
								"id": 141,
								"name": "uint256",
								"nodeType": "ElementaryTypeName",
								"src": "63:7:1",
								"typeDescriptions": {
									"typeIdentifier": "t_uint256",
									"typeString": "uint256"
								}
							}
						},
						"value": null,
						"visibility": "internal"
					},
					{
						"constant": false,
						"id": 145,
						"name": "totalSupply",
						"nodeType": "VariableDeclaration",
						"scope": 209,
						"src": "84:26:1",
						"stateVariable": true,
						"storageLocation": "default",
						"typeDescriptions": {
							"typeIdentifier": "t_uint256",
							"typeString": "uint256"
						},
						"typeName": {
							"id": 144,
							"name": "uint256",
							"nodeType": "ElementaryTypeName",
							"src": "84:7:1",
							"typeDescriptions": {
								"typeIdentifier": "t_uint256",
								"typeString": "uint256"
							}
						},
						"value": null,
						"visibility": "public"
					},
					{
						"body": {
							"id": 159,
							"nodeType": "Block",
							"src": "160:62:1",
							"statements": [
								{
									"expression": {
										"argumentTypes": null,
										"id": 157,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"id": 150,
												"name": "balances",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 143,
												"src": "166:8:1",
												"typeDescriptions": {
													"typeIdentifier": "t_mapping$_t_address_$_t_uint256_$",
													"typeString": "mapping(address => uint256)"
												}
											},
											"id": 153,
											"indexExpression": {
												"argumentTypes": null,
												"expression": {
													"argumentTypes": null,
													"id": 151,
													"name": "msg",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 2937,
													"src": "175:3:1",
													"typeDescriptions": {
														"typeIdentifier": "t_magic_message",
														"typeString": "msg"
													}
												},
												"id": 152,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"memberName": "sender",
												"nodeType": "MemberAccess",
												"referencedDeclaration": null,
												"src": "175:10:1",
												"typeDescriptions": {
													"typeIdentifier": "t_address",
													"typeString": "address"
												}
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "166:20:1",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"id": 156,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"id": 154,
												"name": "totalSupply",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 145,
												"src": "189:11:1",
												"typeDescriptions": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"id": 155,
												"name": "_initialSupply",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 147,
												"src": "203:14:1",
												"typeDescriptions": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												}
											},
											"src": "189:28:1",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"src": "166:51:1",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"id": 158,
									"nodeType": "ExpressionStatement",
									"src": "166:51:1"
								}
							]
						},
						"documentation": null,
						"id": 160,
						"implemented": true,
						"isConstructor": true,
						"isDeclaredConst": false,
						"modifiers": [],
						"name": "Bank",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 148,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 147,
									"name": "_initialSupply",
									"nodeType": "VariableDeclaration",
									"scope": 160,
									"src": "129:22:1",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_uint256",
										"typeString": "uint256"
									},
									"typeName": {
										"id": 146,
										"name": "uint256",
										"nodeType": "ElementaryTypeName",
										"src": "129:7:1",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "128:24:1"
						},
						"payable": false,
						"returnParameters": {
							"id": 149,
							"nodeType": "ParameterList",
							"parameters": [],
							"src": "160:0:1"
						},
						"scope": 209,
						"src": "115:107:1",
						"stateMutability": "nonpayable",
						"superFunction": null,
						"visibility": "public"
					},
					{
						"body": {
							"id": 195,
							"nodeType": "Block",
							"src": "295:136:1",
							"statements": [
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"commonType": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												},
												"id": 177,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"leftExpression": {
													"argumentTypes": null,
													"commonType": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													},
													"id": 175,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"leftExpression": {
														"argumentTypes": null,
														"baseExpression": {
															"argumentTypes": null,
															"id": 170,
															"name": "balances",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 143,
															"src": "309:8:1",
															"typeDescriptions": {
																"typeIdentifier": "t_mapping$_t_address_$_t_uint256_$",
																"typeString": "mapping(address => uint256)"
															}
														},
														"id": 173,
														"indexExpression": {
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 171,
																"name": "msg",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 2937,
																"src": "318:3:1",
																"typeDescriptions": {
																	"typeIdentifier": "t_magic_message",
																	"typeString": "msg"
																}
															},
															"id": 172,
															"isConstant": false,
															"isLValue": false,
															"isPure": false,
															"lValueRequested": false,
															"memberName": "sender",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "318:10:1",
															"typeDescriptions": {
																"typeIdentifier": "t_address",
																"typeString": "address"
															}
														},
														"isConstant": false,
														"isLValue": true,
														"isPure": false,
														"lValueRequested": false,
														"nodeType": "IndexAccess",
														"src": "309:20:1",
														"typeDescriptions": {
															"typeIdentifier": "t_uint256",
															"typeString": "uint256"
														}
													},
													"nodeType": "BinaryOperation",
													"operator": "-",
													"rightExpression": {
														"argumentTypes": null,
														"id": 174,
														"name": "_value",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 164,
														"src": "332:6:1",
														"typeDescriptions": {
															"typeIdentifier": "t_uint256",
															"typeString": "uint256"
														}
													},
													"src": "309:29:1",
													"typeDescriptions": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												},
												"nodeType": "BinaryOperation",
												"operator": ">=",
												"rightExpression": {
													"argumentTypes": null,
													"hexValue": "30",
													"id": 176,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "342:1:1",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_0_by_1",
														"typeString": "int_const 0"
													},
													"value": "0"
												},
												"src": "309:34:1",
												"typeDescriptions": {
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											],
											"id": 169,
											"name": "require",
											"nodeType": "Identifier",
											"overloadedDeclarations": [
												2940,
												2941
											],
											"referencedDeclaration": 2940,
											"src": "301:7:1",
											"typeDescriptions": {
												"typeIdentifier": "t_function_require_pure$_t_bool_$returns$__$",
												"typeString": "function (bool) pure"
											}
										},
										"id": 178,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "301:43:1",
										"typeDescriptions": {
											"typeIdentifier": "t_tuple$__$",
											"typeString": "tuple()"
										}
									},
									"id": 179,
									"nodeType": "ExpressionStatement",
									"src": "301:43:1"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 185,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"id": 180,
												"name": "balances",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 143,
												"src": "350:8:1",
												"typeDescriptions": {
													"typeIdentifier": "t_mapping$_t_address_$_t_uint256_$",
													"typeString": "mapping(address => uint256)"
												}
											},
											"id": 183,
											"indexExpression": {
												"argumentTypes": null,
												"expression": {
													"argumentTypes": null,
													"id": 181,
													"name": "msg",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 2937,
													"src": "359:3:1",
													"typeDescriptions": {
														"typeIdentifier": "t_magic_message",
														"typeString": "msg"
													}
												},
												"id": 182,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"memberName": "sender",
												"nodeType": "MemberAccess",
												"referencedDeclaration": null,
												"src": "359:10:1",
												"typeDescriptions": {
													"typeIdentifier": "t_address",
													"typeString": "address"
												}
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "350:20:1",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"nodeType": "Assignment",
										"operator": "-=",
										"rightHandSide": {
											"argumentTypes": null,
											"id": 184,
											"name": "_value",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 164,
											"src": "374:6:1",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"src": "350:30:1",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"id": 186,
									"nodeType": "ExpressionStatement",
									"src": "350:30:1"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 191,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"id": 187,
												"name": "balances",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 143,
												"src": "386:8:1",
												"typeDescriptions": {
													"typeIdentifier": "t_mapping$_t_address_$_t_uint256_$",
													"typeString": "mapping(address => uint256)"
												}
											},
											"id": 189,
											"indexExpression": {
												"argumentTypes": null,
												"id": 188,
												"name": "_to",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 162,
												"src": "395:3:1",
												"typeDescriptions": {
													"typeIdentifier": "t_address",
													"typeString": "address"
												}
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "386:13:1",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"nodeType": "Assignment",
										"operator": "+=",
										"rightHandSide": {
											"argumentTypes": null,
											"id": 190,
											"name": "_value",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 164,
											"src": "403:6:1",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"src": "386:23:1",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"id": 192,
									"nodeType": "ExpressionStatement",
									"src": "386:23:1"
								},
								{
									"expression": {
										"argumentTypes": null,
										"hexValue": "74727565",
										"id": 193,
										"isConstant": false,
										"isLValue": false,
										"isPure": true,
										"kind": "bool",
										"lValueRequested": false,
										"nodeType": "Literal",
										"src": "422:4:1",
										"subdenomination": null,
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										},
										"value": "true"
									},
									"functionReturnParameters": 168,
									"id": 194,
									"nodeType": "Return",
									"src": "415:11:1"
								}
							]
						},
						"documentation": null,
						"id": 196,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": false,
						"modifiers": [],
						"name": "transfer",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 165,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 162,
									"name": "_to",
									"nodeType": "VariableDeclaration",
									"scope": 196,
									"src": "244:11:1",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_address",
										"typeString": "address"
									},
									"typeName": {
										"id": 161,
										"name": "address",
										"nodeType": "ElementaryTypeName",
										"src": "244:7:1",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"value": null,
									"visibility": "internal"
								},
								{
									"constant": false,
									"id": 164,
									"name": "_value",
									"nodeType": "VariableDeclaration",
									"scope": 196,
									"src": "257:14:1",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_uint256",
										"typeString": "uint256"
									},
									"typeName": {
										"id": 163,
										"name": "uint256",
										"nodeType": "ElementaryTypeName",
										"src": "257:7:1",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "243:29:1"
						},
						"payable": false,
						"returnParameters": {
							"id": 168,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 167,
									"name": "",
									"nodeType": "VariableDeclaration",
									"scope": 196,
									"src": "289:4:1",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_bool",
										"typeString": "bool"
									},
									"typeName": {
										"id": 166,
										"name": "bool",
										"nodeType": "ElementaryTypeName",
										"src": "289:4:1",
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "288:6:1"
						},
						"scope": 209,
						"src": "226:205:1",
						"stateMutability": "nonpayable",
						"superFunction": null,
						"visibility": "public"
					},
					{
						"body": {
							"id": 207,
							"nodeType": "Block",
							"src": "508:34:1",
							"statements": [
								{
									"expression": {
										"argumentTypes": null,
										"baseExpression": {
											"argumentTypes": null,
											"id": 203,
											"name": "balances",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 143,
											"src": "521:8:1",
											"typeDescriptions": {
												"typeIdentifier": "t_mapping$_t_address_$_t_uint256_$",
												"typeString": "mapping(address => uint256)"
											}
										},
										"id": 205,
										"indexExpression": {
											"argumentTypes": null,
											"id": 204,
											"name": "_owner",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 198,
											"src": "530:6:1",
											"typeDescriptions": {
												"typeIdentifier": "t_address",
												"typeString": "address"
											}
										},
										"isConstant": false,
										"isLValue": true,
										"isPure": false,
										"lValueRequested": false,
										"nodeType": "IndexAccess",
										"src": "521:16:1",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"functionReturnParameters": 202,
									"id": 206,
									"nodeType": "Return",
									"src": "514:23:1"
								}
							]
						},
						"documentation": null,
						"id": 208,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": true,
						"modifiers": [],
						"name": "balanceOf",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 199,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 198,
									"name": "_owner",
									"nodeType": "VariableDeclaration",
									"scope": 208,
									"src": "454:14:1",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_address",
										"typeString": "address"
									},
									"typeName": {
										"id": 197,
										"name": "address",
										"nodeType": "ElementaryTypeName",
										"src": "454:7:1",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "453:16:1"
						},
						"payable": false,
						"returnParameters": {
							"id": 202,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 201,
									"name": "balance",
									"nodeType": "VariableDeclaration",
									"scope": 208,
									"src": "491:15:1",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_uint256",
										"typeString": "uint256"
									},
									"typeName": {
										"id": 200,
										"name": "uint256",
										"nodeType": "ElementaryTypeName",
										"src": "491:7:1",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "490:17:1"
						},
						"scope": 209,
						"src": "435:107:1",
						"stateMutability": "view",
						"superFunction": null,
						"visibility": "public"
					}
				],
				"scope": 210,
				"src": "26:518:1"
			}
		],
		"src": "0:545:1"
	},
	"compiler": {
		"name": "solc",
		"version": "0.4.24+commit.e67f0147.Emscripten.clang"
	},
	"networks": {},
	"schemaVersion": "2.0.1",
	"updatedAt": "2020-10-22T15:28:26.794Z"
};


//////////////////
// WEBPACK FOOTER
// ./build/contracts/Bank.json
// module id = 1025
// module chunks = 0